import type { RadioGroup as RadioGroupNS } from 'radix-ui';
import { type ReactNode } from 'react';

import { RadioGroupIndicator, RadioGroupItem, RadioGroupRoot } from './styles';

export interface IBaseRadioButtonProps
  extends RadioGroupNS.RadioGroupItemProps {
  dataCy?: string;
}

export const BaseRadioButton = ({
  dataCy = 'radio-button',
  ...props
}: IBaseRadioButtonProps): JSX.Element => {
  return (
    <RadioGroupItem {...props} data-cy={dataCy}>
      <RadioGroupIndicator />
    </RadioGroupItem>
  );
};

export interface IBaseRadioGroupProps extends RadioGroupNS.RadioGroupProps {
  children: ReactNode;
  dataCy?: string;
}

export const BaseRadioGroup = ({
  children,
  dataCy = 'radio-group',
  ...props
}: IBaseRadioGroupProps): JSX.Element => {
  return (
    <RadioGroupRoot {...props} data-cy={dataCy}>
      {children}
    </RadioGroupRoot>
  );
};

export const BaseRadioGroupIndicator = ({
  ...props
}: RadioGroupNS.RadioGroupIndicatorProps): JSX.Element => {
  return <RadioGroupIndicator {...props} />;
};
